import { Nullable } from "sonobello.utilities.react";

/** Miscellaneous datum that are resolved based on inputs to the medical form. */
export interface IMedicalFormConclusions {
  /** IF not null, The patient is diabetic and has this a1c level. */
  readonly diabetic: Nullable<boolean>;

  /** The patient possesses a pacemaker that does NOT include defibrillator functionality. */
  readonly hasNonDefibrillatorPacemaker: Nullable<boolean>;

  /** The patient has a restriction on radiation exposure to some areas. */
  readonly hasRadiationAreaRestrictions: Nullable<boolean>;
}

/** Empty implementation of {@link IMedicalFormConclusions}. */
export class NullMedicalFormData implements IMedicalFormConclusions {
  readonly diabetic: Nullable<boolean> = null;
  readonly hasNonDefibrillatorPacemaker: Nullable<boolean> = null;
  readonly hasRadiationAreaRestrictions: Nullable<boolean> = null;
}
